import { render, staticRenderFns } from "./userNavigation.vue?vue&type=template&id=68251839&scoped=true"
import script from "./userNavigation.vue?vue&type=script&lang=js"
export * from "./userNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68251839",
  null
  
)

export default component.exports